import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import dialogPattern from '../../../../assets/dialog_pattern_desktop.png';
import promoLinkGift from '../../../../assets/promo/promo_link_gift.webp';
import { useStores } from '../../../../stores/useStores';
import Button from '../../../buttons/Button';
import { DialogBox } from '../../../Dialog/DialogBox';
import { CrossIcon } from '../../../SVGIcons/CrossIcon';
import { getInvalidPromoCodeToMsgMap } from '../InvalidPromoDialog/constants';
import type { InvalidPromoErrorReason } from '../InvalidPromoDialog/types';

import styles from './InvalidPromoDialog.module.scss';

const InvalidPromoDialogNew = observer(() => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { portalStore, promotionStore } = useStores();
  const { t } = useTranslation();

  const { options } = portalStore;

  const removePcQueryParam = () => {
    if (searchParams.has('pc')) {
      searchParams.delete('pc');
      setSearchParams(searchParams);
    }
  };

  const closeDialog = () => {
    removePcQueryParam();
    promotionStore.closePromotionDialog();
  };

  const onCloseHandler = () => {
    promotionStore.sendAnalyticsEvent({ event_action: 'click', click_location: 'close', button_text: 'close' });
    closeDialog();
  };

  const onCtaClickHandler = () => {
    promotionStore.sendAnalyticsEvent({ event_action: 'click', click_location: 'cta', button_text: 'GOT IT' });
    closeDialog();
  };

  const errorCode = options.errorCode as InvalidPromoErrorReason;
  const errorMsg = getInvalidPromoCodeToMsgMap()[errorCode || 'PromoCodeInactiveError'];

  return (
    <div className={styles.dialogContainer}>
      <button
        aria-label={t('common.close')}
        className={styles.closeButton}
        data-testid="closeButton"
        type="button"
        onClick={onCloseHandler}
      >
        <CrossIcon />
      </button>

      <DialogBox className={styles.invalidPromoDialog}>
        <img alt="" className={styles.patternImage} src={dialogPattern} />

        <div className={styles.contentWrapper}>
          <div className={styles.topSection}>
            <div className={styles.textSection}>
              <h2 className={styles.title}>{t('dialogs.oops')}</h2>
              <p className={styles.errorMessage}>{errorMsg || t('promoCode.errors.technicalError')}</p>
            </div>

            <div className={styles.imageSection}>
              <img alt="" className={styles.giftImage} src={promoLinkGift} />
            </div>
          </div>

          <div className={styles.ctaSection}>
            <Button className={styles.gotItButton} onClick={onCtaClickHandler}>
              {t('buttons.gotIt')}
            </Button>
          </div>
        </div>
      </DialogBox>
    </div>
  );
});

export default InvalidPromoDialogNew;
